import { useCallback, useState } from 'react';

/**
 * Light / dark preference (dcon design system). `system` removes the
 * data-theme attribute so the tokens follow the operating system; the
 * no-flash script in index.html applies a saved choice before first paint.
 */
export const THEME_STORAGE_KEY = 'dcon-theme';
export const THEME_CHOICES = ['system', 'light', 'dark'];

export function readThemeChoice() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'system';
  } catch {
    return 'system';
  }
}

export function applyThemeChoice(choice, root = document.documentElement) {
  if (choice === 'light' || choice === 'dark') {
    root.dataset.theme = choice;
  } else {
    delete root.dataset.theme;
  }
  try {
    if (choice === 'light' || choice === 'dark') localStorage.setItem(THEME_STORAGE_KEY, choice);
    else localStorage.removeItem(THEME_STORAGE_KEY);
  } catch {
    // Storage blocked (private window): the choice lasts for this page only.
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState(readThemeChoice);
  const setTheme = useCallback((choice) => {
    const next = THEME_CHOICES.includes(choice) ? choice : 'system';
    applyThemeChoice(next);
    setThemeState(next);
  }, []);
  return { theme, setTheme };
}
